import { flow, O, pipe, RA, s } from "@scripts/fp-ts";
import type { RatingInsurerU } from "@scripts/generated/domaintables/ratingInsurers";
import { mapOrEmpty } from "@scripts/react/components/Empty";
import { Modal, type ModalDismissable, type ModalOpenable } from "@scripts/react/components/modal/Modal";
import { oxfordCommaString } from "@scripts/react/util/oxfordComma";

import insuranceIcon from "@svgs/insurance.svg";


export const RatingInsuranceModal = (props: ModalOpenable & ModalDismissable & { insurers: O.Option<ReadonlyArray<RatingInsurerU>> }) => {
  return pipe(
    props.insurers,
    mapOrEmpty(flow(
      RA.map(_ => _.name),
      RA.uniq(s.Eq),
      oxfordCommaString,
      mapOrEmpty(is => <Modal
        dismissAction={props.dismissAction}
        id="rating-insurance"
        title="Rating Insurance"
        icon={O.some(insuranceIcon)}
        type="primary"
        open={props.modalOpen}
        size="modal-lg"
        body={`Insured by ${is}.`}
      />)
    ))
  );
};
